/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class JiraServiceManagementCostRecommendationMapping {
    getFixupPrototypeFunction() { return JiraServiceManagementCostRecommendationMapping.fixupPrototype; }

    static newInstance(model: Partial<JiraServiceManagementCostRecommendationMapping>): JiraServiceManagementCostRecommendationMapping {
        let obj = Object.assign(new JiraServiceManagementCostRecommendationMapping(), model);
        JiraServiceManagementCostRecommendationMapping.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<JiraServiceManagementCostRecommendationMapping>): JiraServiceManagementCostRecommendationMapping {
        if (!model) return null;
        return JiraServiceManagementCostRecommendationMapping.newInstance(<JiraServiceManagementCostRecommendationMapping> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: JiraServiceManagementCostRecommendationMapping) {
        if (!obj) return;

        models.JiraServiceManagementCostRecommendationMapping.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: JiraServiceManagementCostRecommendationMapping): boolean {
        Object.setPrototypeOf(obj, JiraServiceManagementCostRecommendationMapping.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.attribute_mappings) {
            for (let val of this.attribute_mappings) {
                models.JiraServiceManagementChangeManagementConfigurationMappingForCostRecommendation.fixupPrototype(val);
            }
        }
    }

    /**
     * List of Cost Recommendation attribute mappings.
     */
    attribute_mappings: Array<models.JiraServiceManagementChangeManagementConfigurationMappingForCostRecommendation>;

}
